import { DASHCOLORS } from 'bd-web-components'
import styled, { css } from 'styled-components'

export const TableContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  height: max-content;
  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
    height: max-content;
  }
`
export const LoaderBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 150px;
  padding-bottom: 16px;
  @media (max-width: 768px) {
  }
`

// ----------------------------------------------------------------

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1325px;
  margin: 0 auto;
  padding: 0px 64px;
  height: 100%;
  @media (max-width: 768px) {
    padding: 0px 24px;
  }
`

export const TableTag = styled.p`
  margin-top: 10px;
  color: ${DASHCOLORS.PRIMARY_BLUE_02};
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  margin-bottom: 12px;
  @media (max-width: 768px) {
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: 14.5px;
    margin-bottom: 12px;
  }
`

// export const CloseButton = styled.button`
//   border: none;
//   align-self: center;
//   justify-self: center;
//   background-color: transparent;
//   cursor: pointer;
//   @media (max-width: 600px) {
//     margin-left: 20px;
//   }
// `

// export const ModalContainerTop = styled.div`
//   padding-bottom: 25px;
//   display: flex;
//   flex-direction: row;
//   border-bottom: 2px solid ${DASHCOLORS.GRAY_SCALE_08};
//   margin-bottom: 33px;
// `

// export const ModalContainerBottom = styled.div`
//   display: flex;
//   width: 100%;
//   flex-direction: row;
//   align-items: space-between;
//   justify-content: space-between;
// `

// export const Space = styled.div`
//   width: 10px;
// `

// export const ModalTitle = styled.h5`
//   color: #000;
// //   font-size: 16px;
//   font-style: normal;
//   font-weight: 600;
//   line-height: 22.4px;
//   margin-bottom: 8px;
//   @media (max-width: 768px) {
//   //     font-size: 14px;
//     font-style: normal;
//     font-weight: 600;
//     line-height: 19.6px;
//   }
// `

// export const ModalSubText = styled.p`
//   color: ${DASHCOLORS.GRAY_SCALE_05};
// //   font-size: 14px;
//   font-style: normal;
//   font-weight: 400;
//   line-height: 19.6px;
//   @media (max-width: 768px) {
//   //     font-size: 12px;
//     font-style: normal;
//     font-weight: 400;
//     line-height: normal;
//   }
// `

export const FinancialClosingButtons = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  grid-gap: 8px;
  padding: 16px 0px;

  &.block {
    display: block;

    button {
      width: 100%;
      margin-bottom: 10px;
    }
  }
`

export const Button = styled.button`
  padding: 10px 35px;
  border: 1px solid ${DASHCOLORS.SECONDARY_ORANGE_01};
  background-color: ${DASHCOLORS.SECONDARY_ORANGE_01};
  color: ${DASHCOLORS.WHITE};
  border-radius: 8px;
  font-weight: 600;
  padding: 10px 56px;
  font-size: 12px;
  cursor: pointer;

  &.large {
    font-size: 14px;
    min-height: 45px;
  }

  &.outlined {
    padding: 10px 35px;
    color: ${DASHCOLORS.PRIMARY_BLUE_01};
    background-color: transparent;

    &.default {
      border: 1px solid ${DASHCOLORS.GRAY_SCALE_08};
    }
  }

  &.success {
    color: ${DASHCOLORS.WHITE};
    background-color: ${DASHCOLORS.SECONDARY_GREEN_07};
    border: 1px solid ${DASHCOLORS.SECONDARY_GREEN_07};
  }
`

interface ExceptionContainerProps {
  height: number
  margin: boolean
}

export const PageTitle = styled.h4`
  color: ${DASHCOLORS.PRIMARY_BLUE_02};
  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  line-height: 35.2px; /* 110% */
  margin-top: 0px;
  margin-bottom: 8px;
  @media (max-width: 768px) {
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px; /* 110% */
    margin-top: 0px;
    margin-bottom: 5px;
  }
`

export const PageSubtitle = styled.p`
  color: ${DASHCOLORS.GRAY_SCALE_05};
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  @media (max-width: 768px) {
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin-bottom: 18px;
  }
`

export const TagTitle = styled.p`
  color: ${DASHCOLORS.PRIMARY_BLUE_01};
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  @media (max-width: 768px) {
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
`

export const TagTitleBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 16px;
  margin-top: 24px;
`

export const PixelLogo = styled.img`
  width: 22px;
  height: 22px;
  margin-right: 10px;
  @media (max-width: 768px) {
    margin-right: 10px;
  }
`

export const PageHeaderBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  width: 100%;
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    max-width: 100%;
  }
`

export const TextHeaderBox = styled.div`
  width: 70%;
  @media (max-width: 768px) {
    width: 100%;
  }
`

export const ButtonHeaderBox = styled.div`
  width: 30%;
  display: flex;
  justify-content: flex-end;
  @media (max-width: 768px) {
    width: 100%;
    max-width: 100%;
    justify-content: flex-start;
  }
`

export const FormDivider = styled.div`
  background-color: ${DASHCOLORS.GRAY_SCALE_08};
  width: 100%;
  height: 2px;
  margin-top: 29px;
  margin-bottom: 0px;
  @media (max-width: 768px) {
    margin-top: 0px;
    margin-bottom: 0px;
  }
`

export const StyledForm = styled.form``

export const GridForm = styled.div`
  display: grid;
  max-width: 660px;
  grid-template-columns: repeat(33, 20px);
  /* Ordem: Facebook, TikTok, GA4 (row 5), depois Google ADS (row 7) */
  grid-template-rows: 80px 35px 80px 35px 80px 28px minmax(80px, auto) 35px 35px 50px;
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    grid-template-rows: repeat(4, 80px 35px) 35px 35px 50px;
  }
`

export const FacebookBox = styled.div`
  grid-column-start: 1;
  grid-column-end: 34;
  grid-row-start: 1;
  grid-row-end: 2;
  @media (max-width: 768px) {
    grid-column-start: 1;
    grid-column-end: 34;
    grid-row-start: 1;
    grid-row-end: 2;
  }
`
export const TikTokBox = styled.div`
  grid-column-start: 1;
  grid-column-end: 34;
  grid-row-start: 3;
  grid-row-end: 4;
  @media (max-width: 768px) {
    grid-column-start: 1;
    grid-column-end: 34;
    grid-row-start: 3;
    grid-row-end: 4;
  }
`
export const GoogleBox = styled.div`
  grid-column-start: 1;
  grid-column-end: 34;
  grid-row-start: 5;
  grid-row-end: 6;
  @media (max-width: 768px) {
    grid-column-start: 1;
    grid-column-end: 34;
    grid-row-start: 5;
    grid-row-end: 6;
  }
`
export const GoogleAdsBox = styled.div`
  grid-column-start: 1;
  grid-column-end: 34;
  grid-row-start: 7;
  grid-row-end: 8;
  align-self: start;
  @media (max-width: 768px) {
    grid-column-start: 1;
    grid-column-end: 34;
    grid-row-start: 7;
    grid-row-end: 8;
  }
`

export const PixelRow = styled.div`
  margin-bottom: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid ${DASHCOLORS.GRAY_SCALE_08};

  &:last-of-type {
    border-bottom: none;
    margin-bottom: 0;
    padding-bottom: 0;
  }
`

export const PixelRowFirstLine = styled.div`
  width: 100%;
  margin-bottom: 16px;
`

export const PixelRowSecondLine = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: stretch;
`

export const PixelRowSecondLineFields = styled.div`
  display: flex;
  gap: 16px;
  align-items: flex-end;

  & > * {
    flex: 1;
    min-width: 140px;
  }
`

export const RemovePixelButtonWrap = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
`

export const AddPixelButtonWrap = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  margin-top: 8px;
`

export const AddPixelButton = styled.button`
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 500;
  color: ${DASHCOLORS.PRIMARY_BLUE_01};
  background: transparent;
  border: 1px dashed ${DASHCOLORS.GRAY_SCALE_08};
  border-radius: 8px;
  cursor: pointer;

  &:hover {
    background: ${DASHCOLORS.GRAY_SCALE_09};
  }
`

export const RemovePixelButton = styled.button`
  padding: 8px 12px;
  font-size: 12px;
  color: ${DASHCOLORS.PRIMARY_RED_02 || '#c62828'};
  background: transparent;
  border: 1px solid ${DASHCOLORS.GRAY_SCALE_08};
  border-radius: 8px;
  cursor: pointer;

  &:hover {
    background: ${DASHCOLORS.GRAY_SCALE_09};
  }
`

export const SaveButtonBox = styled.div<any>`
  grid-column-start: 16;
  grid-column-end: 34;
  grid-row-start: 10;
  grid-row-end: 11;
  ${(props) =>
    props.full === true &&
    css`
      grid-column-start: 1;
      grid-column-end: 34;
    `}
  @media (max-width: 768px) {
    grid-column-start: 1;
    grid-column-end: 34;
    grid-row-start: 12;
    grid-row-end: 13;
  }
`
export const CancelButtonBox = styled.div`
  grid-column-start: 1;
  grid-column-end: 15;
  grid-row-start: 10;
  grid-row-end: 11;
  @media (max-width: 768px) {
    grid-column-start: 1;
    grid-column-end: 34;
    grid-row-start: 10;
    grid-row-end: 11;
  }
`
export const ExceptionContainer = styled(styled.div``)<ExceptionContainerProps>`
  display: flex;
  justify-content: center;
  align-items: center;

  ${(props) =>
    props.height !== undefined &&
    css`
      height: ${props.height}px;
    `}
  ${(props) =>
    props.margin &&
    css`
      margin-bottom: 100px;
    `}
`
